// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".keywords_suggest-module__wrapper--3zSxK{margin-bottom:20px;border-top:1px solid #c6ced5;border-bottom:1px solid #c6ced5;padding:24px 0px}.keywords_suggest-module__title--IPj2g{font-weight:500;font-size:16px;line-height:24px;letter-spacing:0px;margin-bottom:16px}\n", ""]);
// Exports
exports.locals = {
	"wrapper": "keywords_suggest-module__wrapper--3zSxK",
	"title": "keywords_suggest-module__title--IPj2g"
};
module.exports = exports;
